import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updatePriceBand } from 'src/api/updatePriceBand/updatePriceBand';
import { IPatchPriceBandResponse } from 'src/api/updatePriceBand/types';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { QueryKeys } from '../QueryKeys';

type TUpdatePriceBand = { id: string; priceBandId: string; name?: string; venues?: string[] };

export const useUpdatePriceBand = (onMutationSuccess: () => void) => {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();

  return useMutation(
    async ({ id, priceBandId, name, venues }: TUpdatePriceBand) =>
      await updatePriceBand(id, priceBandId, {
        ...(name && { name }),
        ...(venues && { venues }),
      }),
    {
      onSuccess: async (data: IPatchPriceBandResponse) => {
        await queryClient.invalidateQueries({ queryKey: [getBrandId(), QueryKeys.priceBands] });
        showSnackbar({
          message: `You have successfully updated price band ${data.name}`,
          status: SnackbarStatus.SUCCESS,
        });
        onMutationSuccess();
      },
      onError: () => {
        showSnackbar({
          message: 'Something went wrong whilst updating a price band.',
          status: SnackbarStatus.ERROR,
        });
      },
    },
  );
};
